import * as React from 'react';
import ReactTooltip from 'react-tooltip';
import ComboBox from '../../../components/ComboBox/ComboBox';
import { useCallback } from 'react';

type ComboBoxOptionProps = {
    values: { key: string, name: string }[];
    value: string;
    label: string;
    tooltip: string;
    tooltipId: string;
    onChange: (newVal: string) => void;
    className?: string;
    width?: string;
}

export function ComboBoxOption({ className, values, value, onChange, label, tooltip, tooltipId, width }: ComboBoxOptionProps) {

    const renderItemCb = useCallback((dateRangeItem) => {
        return <div className="ComboBoxOption__Item">
            {dateRangeItem.name}
        </div>;
    }, []);

    const onValueSelectCb = useCallback((dateRangeItem) => {
        onChange(dateRangeItem.key);
    }, [onChange]);

    return <div className="text-chat-options_table_row">
        <div className={`text-chat-options_font-size ${className}`}>
            <span className="text-chat-options_label"
                data-place="bottom"
                data-multiline="true"
                data-effect="solid"
                data-class="tutor-light-tooltip tutor-no-arrow-tooltip tutor-light-tooltip-240 text-chat-option-tooltip"
                data-for={tooltipId}
                data-tip={tooltip}>{label}</span>
            <ReactTooltip id={tooltipId} />
            <ComboBox
                classes="ComboBoxOption__Cb"
                values={values}
                valueKey="key"
                valueName="name"
                width={width || '164px'}
                selectedValueId={value}
                renderItem={renderItemCb}
                onValueSelect={onValueSelectCb}
            />
        </div>
    </div>;
}